import React from 'react'
import { IconProps } from './icons.models'

export const UserIcon: React.FC<IconProps> = ({
    width = 12,
    height = 12,
    fillColor = '#99A1AF',
}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.5 10.5V9.5C9.5 8.96957 9.28929 8.46086 8.91421 8.08579C8.53914 7.71071 8.03043 7.5 7.5 7.5H4.5C3.96957 7.5 3.46086 7.71071 3.08579 8.08579C2.71071 8.46086 2.5 8.96957 2.5 9.5V10.5" stroke={fillColor} strokeLinecap="round" strokeLinejoin="round" />
            <path d="M6 5.5C7.10457 5.5 8 4.60457 8 3.5C8 2.39543 7.10457 1.5 6 1.5C4.89543 1.5 4 2.39543 4 3.5C4 4.60457 4.89543 5.5 6 5.5Z" stroke={fillColor} strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}
